export const getUnreadNotificationsCount = (state) =>
  state.userNotifications.unreadCount;
